import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Snackbar, Alert } from '@mui/material';

const MappingNotification = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const mappings = useSelector(state => state.treeData.mappingStates.mappings);
  const [prevMappingsLength, setPrevMappingsLength] = useState(mappings.length);

  useEffect(() => {
    if (mappings.length > prevMappingsLength) {
      const latestMapping = mappings[mappings.length - 1];
      const mappingType = latestMapping?.mappingType === 'right-to-right' ? 'Right-to-right' : 'Left-to-right';
      setMessage(`${mappingType} mapping created! Total mappings: ${mappings.length}`);
      setOpen(true);
    } else if (mappings.length < prevMappingsLength && mappings.length >= 0) {
      setMessage(`Mapping removed! Total mappings: ${mappings.length}`);
      setOpen(true);
    }
    setPrevMappingsLength(mappings.length);
  }, [mappings.length, prevMappingsLength, mappings]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar 
      open={open} 
      autoHideDuration={3000} 
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default MappingNotification; 